import { render, staticRenderFns } from "./MonitoringFeaturesTableWidget.vue?vue&type=template&id=25f4a32e"
import script from "./MonitoringFeaturesTableWidget.vue?vue&type=script&lang=js"
export * from "./MonitoringFeaturesTableWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports